import { VideoPlayerContextValue } from "../types";
import { PropsWithChildren, RefObject, createContext, useContext, useState } from "react";
import { MediaPlayerInstance } from "@vidstack/react";

export const VideoPlayerContext = createContext<VideoPlayerContextValue>({
	playerRef: null,
	canPlay: false,
	isPlaying: false,
	setIsPlaying: (isPlaying: boolean) => void 0,
});

export const useVideoPlayer = () => useContext(VideoPlayerContext);

export interface VideoPlayerContextProviderProps {
	playerRef: RefObject<MediaPlayerInstance> | null;
	canPlay: boolean;
}

export function VideoPlayerContextProvider({ children, playerRef, canPlay = false }: PropsWithChildren<VideoPlayerContextProviderProps>) {
	const [isPlaying, setIsPlaying] = useState(false);

	return <VideoPlayerContext.Provider value={{ playerRef, canPlay, isPlaying, setIsPlaying }}>{children}</VideoPlayerContext.Provider>;
}
